import axios from "axios";
import router from "@/router";
import qs from "qs";
import {
  Message,
  Loading
} from "element-ui";

//axios 全局默认设置
axios.defaults.baseURL = "http://runhill.com.au/";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

//axios 实例对象
let http = axios.create({
  timeout: 20000,
  headers: { 
    //   'Content-Type': 'application/json',
       // "Content-Type": "application/x-www-form-urlencoded",
        "Content-Type": "application/json;charset=utf-8",
        // "Content-Type": "multipart/form-data;charset=UTF-8",
     },
  // 自定义路径参数序列化方式
  paramsSerializer: params => {

    return Object.keys(params)
      .map(key => {
        const param = params[key]
        if (param === null || param === undefined) return
        if (isPlainObject(param) || isArray(param)) {
          return `${key}=${encodeURIComponent(JSON.stringify(param))}`
        } else {
          return `${key}=${param}`
        }
      })
      .filter(str => str)
      .join('&')
  },
});

// http http request 拦截器
// http.interceptors.request.use(
//   config => {
//     if (localStorage.token) {
//       config.headers.token = JSON.parse(localStorage.token);
//     } else {
//       router.replace("/");
//     }
//     return config;
//   },
//   error => Promise.error(error)
// );

//http response 拦截器
http.interceptors.response.use(
  response => {
    let config = response.data;
    if (response.status === 200) {
      if (typeof response.data !== "object") {
        config = JSON.parse(config.replace(/\n/g, "\\n").replace(/\r/g, "\\r"));
      }
      return config;
    } else if (response.status === 201) {
      return response.data;
    } else if (response.status === 202) {
      // Message({
      //   type: "success",
      //   message: response.data
      // });
      if (typeof response.data !== "object") {
        config = JSON.parse(config.replace(/\n/g, "\\n").replace(/\r/g, "\\r"));
      }
      return config;
    } else {
      Message({
        type: "success",
        message: "操作成功"
      });
    }
  },
  error => {
    if (error.response.status === 403) {
      window.localStorage.clear();
      let loadingInstance = Loading.service({
        text: "你的账号失效， 请重新登录..."
      });
      setTimeout(() => {
        loadingInstance.close();
        this.$router.replace("/");
      }, 1000);
    }
    Message({
      type: "error",
      message: error.response.data
    });
    return Promise.reject(error);
  }
);

export default http;


// WEBPACK FOOTER //
// ./src/http.js